/* eslint-disable import/no-anonymous-default-export */
import {
  GET_NAVIGATION_ROUTES_FROM_CMS,
  GET_CMS_SITE_SECTIONS_TITLE,
  GET_CMS_PRODUCTOS_AHORRO_CREDITO,
  GET_CMS_BARRA_INTERMEDIA,
  GET_CMS_MAIN_MENU_SECTIONS,
} from "../actions/types";

const initialState = [];
const META_NOT_FOUND = {
  name: "NotFound",
  keywords: "No encontrado, página no encontrada, 404",
  title: "Página No Encontrada",
  h1: "404 Página No Encontrada",
  description: "404 Página No Encontrada",
  url: "*",
  component: "NotFound",
  identificadorSitio: null,
};

const cmsReducer = function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_NAVIGATION_ROUTES_FROM_CMS:
      return {
        ...state,
        rutas: [...payload, META_NOT_FOUND],
      };
    case GET_CMS_SITE_SECTIONS_TITLE:
      return {
        ...state,
        seccion: payload,
      };
    case GET_CMS_PRODUCTOS_AHORRO_CREDITO:
      return {
        ...state,
        productos: payload.data.productosAhorroYCredito[0].bag.contentItems,
      };
    case GET_CMS_BARRA_INTERMEDIA:
      return {
        ...state,
        barraIntermedia: payload.data.aCBarraIntermedia,
      };
    case GET_CMS_MAIN_MENU_SECTIONS:
      return {
        ...state,
        mainMenuSections: payload,
      };
    default:
      return state;
  }
};

export default cmsReducer;
